import { NavLink } from "react-router-dom";
import child1 from "../../images/child-image-1.webp";
import child2 from "../../images/child-image-2.webp";
import child3 from "../../images/child-image-3.webp";
import child4 from "../../images/child-image-4.webp";

const TrustedCustomers = () => {
  return (
    <div className="flex flex-col items-center py-[50px]">
      <div className="flex items-center justify-center">
        <img
          src={child1}
          className="h-[60px] w-[60px] border-[1px] border-white rounded-full relative left-[0px]"
          alt=""
        />
        <img
          src={child2}
          className="h-[60px] w-[60px] border-[1px] border-white rounded-full relative left-[-15px]"
          alt=""
        />
        <img
          src={child3}
          className="h-[60px] w-[60px] border-[1px] border-white rounded-full relative left-[-25px]"
          alt=""
        />
        <img
          src={child4}
          className="h-[60px] w-[60px] border-[1px] border-white rounded-full relative left-[-35px]"
          alt=""
        />
      </div>
      <h2 className="text-[30px] lg:text-[40px] font-[700] my-[10px] text-center">
        Trusted by over 10K+ customers
      </h2>
      <div className="flex flex-wrap gap-4 justify-center w-[100%] my-[20px]">
        <NavLink
          to="/phones"
          onClick={() => window.scrollTo({ top: 0 })}
          className="bg-red-200 py-[20px] w-[100%] md:w-[45%] lg:w-[30%] rounded-full flex items-center justify-between px-[15px] hover:bg-red-300"
        >
          <div className="flex w-[50%] items-center gap-3 leading-2 text-left">
            <i class="fa-solid fa-mobile-screen"></i>
            <h4>PHONES</h4>
          </div>
          <i class="fa-solid fa-arrow-right bg-white p-[15px] rounded-full"></i>
        </NavLink>
        <NavLink
          to="/games"
          onClick={() => window.scrollTo({ top: 0 })}
          className="bg-blue-200 py-[20px] w-[100%] md:w-[45%] lg:w-[30%] rounded-full flex items-center justify-between px-[15px] hover:bg-blue-300"
        >
          <div className="flex w-[50%] items-center gap-3 leading-2 text-left">
            <i class="fa-solid fa-gamepad"></i>
            <h4>GAMES</h4>
          </div>
          <i class="fa-solid fa-arrow-right bg-white p-[15px] rounded-full"></i>
        </NavLink>
        <NavLink
          to="/appliances"
          onClick={() => window.scrollTo({ top: 0 })}
          className="bg-green-200 py-[20px] w-[100%] md:w-[45%] lg:w-[30%] rounded-full flex items-center justify-between px-[15px] hover:bg-green-300"
        >
          <div className="flex w-[50%] items-center gap-3 leading-2 text-left">
            <i class="fa-solid fa-blender-phone"></i>
            <h4>APPLIANCES</h4>
          </div>
          <i class="fa-solid fa-arrow-right bg-white p-[15px] rounded-full"></i>
        </NavLink>
        <NavLink
          to="/accessories"
          onClick={() => window.scrollTo({ top: 0 })}
          className="bg-yellow-200 py-[20px] w-[100%] md:w-[45%] lg:w-[30%] rounded-full flex items-center justify-between px-[15px] hover:bg-yellow-300"
        >
          <div className="flex w-[50%] items-center gap-3 leading-2 text-left">
            <i class="fa-solid fa-shirt"></i>
            <h4>ACCESSORIES</h4>
          </div>
          <i class="fa-solid fa-arrow-right bg-white p-[15px] rounded-full"></i>
        </NavLink>
        <NavLink
          to="/laptop"
          onClick={() => window.scrollTo({ top: 0 })}
          className="bg-orange-200 py-[20px] w-[100%] md:w-[45%] lg:w-[30%] rounded-full flex items-center justify-between px-[15px] hover:bg-orange-300"
        >
          <div className="flex w-[50%] items-center gap-3 leading-2 text-left">
            <i class="fa-solid fa-laptop"></i>
            <h4>LAPTOP</h4>
          </div>
          <i class="fa-solid fa-arrow-right bg-white p-[15px] rounded-full"></i>
        </NavLink>
      </div>
    </div>
  );
};

export default TrustedCustomers;
